// extracted by mini-css-extract-plugin
export default {"root":"SelectResource_root__GnLOa","item":"SelectResource_item__qY3jF"};